module.exports = __webpack_public_path__ + "img/acc85e0bd9135ee8a2d0fd68e73c637a.png";